export const SUPPORT_CHAT_OPEN_EVENT = 'dentrist:open-support-chat';

export const SUPPORT_CHAT_PATH = '/support-chat';

export const SUPPORT_REPLY_NOTIFICATION_TYPE = 'support.reply';

export const openSupportChat = () => {
  window.dispatchEvent(new CustomEvent(SUPPORT_CHAT_OPEN_EVENT));
};

export const isSupportReplyNotification = (notification) =>
  notification?.type === SUPPORT_REPLY_NOTIFICATION_TYPE;
